import React from 'react';

// Container fluido: ocupa toda a largura da viewport com padding lateral
// responsivo. Não centraliza nem limita largura — é responsabilidade da
// página decidir se algum bloco interno deve ter max-w (forms longos, por
// exemplo, podem usar `max-w-3xl mx-auto` num wrapper próprio).
const Container = ({ children, className = '' }) => {
  return (
    <div className={`w-full px-4 sm:px-6 lg:px-10 xl:px-16 py-6 ${className}`}>
      {children}
    </div>
  );
};

export default Container;
